import React, { useState, useEffect, useRef } from "react";
import { InputText } from "primereact/inputtext";
import { TabView, TabPanel } from 'primereact/tabview';
import { Button } from 'primereact/button';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Toast } from 'primereact/toast';
import configuationManagementService from "@services/configuationManagement.service";

function Import() {
    const [value, setValue] = useState('');
    const [products, setProducts] = useState([]);
    const toast = useRef(null);
    const onClick = (e) => {
        if (value) {
            configuationManagementService.brtel_mci_link_add({ url: value }).then((result) => {
                toast.current.show({ severity: 'success', summary: 'Form Submitted', detail: "Url Added" });
                loadData();
                setValue("");
            }).catch((e) => {
                toast.current.show({ severity: 'error', summary: 'Form Submitted', detail: e.message });
            })
        }
        else {
            toast.current.show({ severity: 'error', summary: 'Form Submitted', detail: "Link is empty" });
        }

    };
    const imageBodyTemplate = (row) => {
        return <a href={row.url} alt={row.url} className="w-6rem shadow-2 border-round" >Link</a>;
    };
    useEffect(() => {
        loadData();
    }, []);
    const loadData = () => {
        configuationManagementService.brtel_mci_link_list().then((result) => {
            setProducts(result.data);
        })
    };
    return (
        <div>
            <div className="card">
                <TabView className="m-4" >
                    <TabPanel header="Add Link">
                        <div className="card flex justify-content-center">
                            <InputText value={value} className="w-1/2" onChange={(e) => setValue(e.target.value)} />
                            <Button label="Add Link" onClick={onClick} />
                        </div>
                    </TabPanel>
                </TabView>
            </div>
            <div className="card">
                <DataTable className="m-4" value={products} tableStyle={{ minWidth: '50rem' }}>
                    <Column field="url" body={imageBodyTemplate} header="url"></Column>
                    <Column field="importOn" header="importOn"></Column>
                    <Column field="parsedOn" header="parsedOn"></Column>
                    <Column field="done" header="done"></Column>
                    <Column field="hasError" header="hasError"></Column>
                    <Column field="fileType" header="fileType"></Column>
                    <Column field="uploadBy" header="uploadBy"></Column>

                </DataTable>
            </div>
            <Toast ref={toast} />
        </div>
    );
}

export default Import;